exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\nbody {\r\n    margin: 0;\r\n    background: #eee;\r\n}\r\n\r\n.content {\r\n    padding: 16px;\r\n}\r\n\r\n.mat-card {\r\n    margin-bottom: 16px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 151
// module chunks = 2